import { FlagCountry } from "../../types";

interface FlagIconProps {
  country: FlagCountry;
  className?: string;
  width?: number;
  height?: number;
}

export const FlagIcon = ({
  country,
  className = "",
  width = 20,
  height = 20,
  ...props
}: FlagIconProps) => {
  const spritesheet =
    window?.resourceUrls?.flagSpriteSheet ??
    "/marketplace/images/sprite-flag.svg";

  return (
    <svg class={`icon ${className}`} width={width} height={height} {...props}>
      <use href={`${spritesheet}#${country}`} />
    </svg>
  );
};
